import React, { useState } from 'react';
import { userRoles } from '../utility/ReUsableFunctions';
import { MenuItem } from './types';
import { URL } from '../../api/tklEnvironments';
// Replace custom icon imports with Lucide React icons
import { 
  Grid3X3, 
  Infinity, 
  Users, 
  BookOpen, 
  FileText, 
  Settings, 
  Award, 
  BarChart3, 
  Target,
  Trophy
} from 'lucide-react';

const mainMenuItems: MenuItem[] = [
  {
    id: 'main-nav',
    title: 'Main Navigation',
    icon: React.createElement(Grid3X3, { 
      size: 20, 
      color: "#E8EAED" 
    }),
    children: [
      {
        id: 'dashboard',
        title: 'PD Dashboard',
        link: '/',
        requiredRoles: [
          userRoles.COMPREHENSIVE_PROGRAM_MEMBER_PAID_USER,
          userRoles.GPLC_PROGRAM_MEMBER_PAID_USER,
          userRoles.MICRO_COURSE_PROGRAM_MEMBER_PAID_USER,
          userRoles.KIDVISION_PROGRAM_MEMBER,
          userRoles.CONTENT_ADMIN,
          userRoles.CONTENT_AUTHOR,
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_ACCOUNT_MANAGER,
          userRoles.TKL_FACILITATOR,
          userRoles.DISTRICT_ADMIN,
          userRoles.DISTRICT_FACILITATOR,
          userRoles.SCHOOL_ADMIN,
          userRoles.SCHOOL_FACILITATOR,
          userRoles.TKL_COMMUNITY_MANAGER
        ],
        icon: React.createElement('i', { className: 'material-icons', style: { fontSize: 20, color: "#E8EAED" } }, 'dashboard')
      },
      {
        id: 'the-loop',
        title: 'The Loop',
        link: '/the-loop',
        requiredRoles: [userRoles.TKL_MEMBER_FREE_USER],
        icon: React.createElement(Infinity, { 
          size: 20, 
          color: "#E8EAED" 
        })
      }
    ]
  },
  {
    id: 'cohort-management',
    title: 'Cohort Management',
    icon: React.createElement(Users, {
      size: 20,
      color: "#E8EAED"
    }),
    children: [
      {
        id: 'assign-courses',
        title: 'Manage Comp Cohorts',
        link: '/manageCohorts',
        requiredRoles: [
          userRoles.CONTENT_ADMIN,
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_ACCOUNT_MANAGER,
          userRoles.TKL_FACILITATOR,
        ]
      },
      {
        id: 'manage-gplc',
        title: 'Manage GPLC Cohorts',
        link: '/manage-cohorts',
        requiredRoles: [
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_FACILITATOR,
          userRoles.TKL_ACCOUNT_MANAGER,
        ]
      },
      {
        id: 'manage-micro',
        title: 'Manage Micro Cohorts',
        link: '/manage-cohorts/micro',
        requiredRoles: [
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_FACILITATOR,
          userRoles.TKL_ACCOUNT_MANAGER,
        ]
      },
      {
        id: 'manage-kidvision',
        title: 'Manage Kidvision Cohorts',
        link: '/manageCohorts',
        requiredRoles: [
          userRoles.CONTENT_ADMIN,
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_ACCOUNT_MANAGER,
          userRoles.TKL_FACILITATOR,
        ]
      }
    ]
  },
  {
    id: 'course-management',
    title: 'Course Management',
    icon: React.createElement(BookOpen, {
      size: 20,
      color: "#E8EAED"
    }),
    children: [
      {
        id: 'create-course',
        title: 'Create Course',
        link: '/create-course',
        requiredRoles: [
          userRoles.CONTENT_ADMIN,
          userRoles.CONTENT_AUTHOR,
        ]
      }
    ]
  },
  {
    id: 'catalogs',
    title: 'Catalogs',
    icon: React.createElement(FileText, {
      size: 20,
      color: "#E8EAED"
    }),
    children: [
      {
        id: 'comprehensive-catalog',
        title: 'Comprehensive Catalog',
        link: localStorage.getItem("token")
          ? "/catalog-comprehensive"
          : "/external-catalog",
        requiredRoles: [ userRoles.ANY_USER ]
      },
      {
        id: 'micro-catalog',
        title: 'Micro Catalog',
        link: '/catalog-micro',
        requiredRoles: [ userRoles.ANY_USER ]
      },
      {
        id: 'gplc-catalog',
        title: 'GPLC Catalog',
        link: '/catalog-gplc',
        requiredRoles: [ userRoles.ANY_USER ]
      },
      {
        id: 'kidvision-catalog',
        title: 'Kidvision Catalog',
        link: '/catalog-KidVision',
        requiredRoles: [ userRoles.ANY_USER ]
      },

      /**
       * ToDo: why is this a duplicate of its parent?
       * ToDo: check if this is needed and define the link 
       */
      {
        id: 'catalogs',
        title: 'Catalogs',
        requiredRoles: [userRoles.INVITED_USER]
      }
    ]
  },
  {
    id: 'leaderboard',
    title: 'Leaderboard',
    icon: React.createElement(BarChart3, {
      size: 20,
      color: "#E8EAED"
    }),
    styles: { marginBottom: '0' },
    children: [
      {
        id: 'my-ranking',
        title: 'My Ranking',
        link: '/rewards',
        requiredRoles: [
          userRoles.TKL_MEMBER_FREE_USER,
          userRoles.COMPREHENSIVE_PROGRAM_MEMBER_PAID_USER,
          userRoles.GPLC_PROGRAM_MEMBER_PAID_USER,
          userRoles.MICRO_COURSE_PROGRAM_MEMBER_PAID_USER,
          userRoles.KIDVISION_PROGRAM_MEMBER,
          userRoles.INVITED_USER,
          userRoles.CONTENT_ADMIN,
          userRoles.CONTENT_AUTHOR,
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_ACCOUNT_MANAGER,
          userRoles.TKL_FACILITATOR,
          userRoles.DISTRICT_ADMIN,
          userRoles.SCHOOL_ADMIN,
          userRoles.DISTRICT_FACILITATOR,
          userRoles.SCHOOL_FACILITATOR,
          userRoles.TKL_COMMUNITY_MANAGER
        ]
      },
      {
        id: 'monthly-challenges',
        title: 'Monthly Challenges',
        link: '/challenges',
        requiredRoles: [
          userRoles.TKL_MEMBER_FREE_USER,
          userRoles.COMPREHENSIVE_PROGRAM_MEMBER_PAID_USER,
          userRoles.GPLC_PROGRAM_MEMBER_PAID_USER,
          userRoles.MICRO_COURSE_PROGRAM_MEMBER_PAID_USER,
          userRoles.KIDVISION_PROGRAM_MEMBER,
          userRoles.INVITED_USER,
          userRoles.CONTENT_ADMIN,
          userRoles.CONTENT_AUTHOR,
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_ACCOUNT_MANAGER,
          userRoles.TKL_FACILITATOR,
          userRoles.DISTRICT_ADMIN,
          userRoles.SCHOOL_ADMIN,
          userRoles.DISTRICT_FACILITATOR,
          userRoles.SCHOOL_FACILITATOR,
          userRoles.TKL_COMMUNITY_MANAGER
        ]
      },
      {
        id: 'rewards',
        title: 'Rewards',
        link: '/rewards',
        requiredRoles: [
          userRoles.TKL_MEMBER_FREE_USER,
          userRoles.COMPREHENSIVE_PROGRAM_MEMBER_PAID_USER,
          userRoles.GPLC_PROGRAM_MEMBER_PAID_USER,
          userRoles.MICRO_COURSE_PROGRAM_MEMBER_PAID_USER,
          userRoles.KIDVISION_PROGRAM_MEMBER,
          userRoles.INVITED_USER,
          userRoles.CONTENT_ADMIN,
          userRoles.CONTENT_AUTHOR,
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_ACCOUNT_MANAGER,
          userRoles.TKL_FACILITATOR,
          userRoles.DISTRICT_ADMIN,
          userRoles.SCHOOL_ADMIN,
          userRoles.DISTRICT_FACILITATOR,
          userRoles.SCHOOL_FACILITATOR,
          userRoles.TKL_COMMUNITY_MANAGER
        ]
      },
      {
        id: 'my-badges',
        title: 'My Badges',
        link: '/badges',
        requiredRoles: [
          userRoles.TKL_MEMBER_FREE_USER,
          userRoles.COMPREHENSIVE_PROGRAM_MEMBER_PAID_USER,
          userRoles.GPLC_PROGRAM_MEMBER_PAID_USER,
          userRoles.MICRO_COURSE_PROGRAM_MEMBER_PAID_USER,
          userRoles.KIDVISION_PROGRAM_MEMBER,
          userRoles.INVITED_USER,
          userRoles.CONTENT_ADMIN,
          userRoles.CONTENT_AUTHOR,
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_ACCOUNT_MANAGER,
          userRoles.TKL_FACILITATOR,
          userRoles.DISTRICT_ADMIN,
          userRoles.SCHOOL_ADMIN,
          userRoles.DISTRICT_FACILITATOR,
          userRoles.SCHOOL_FACILITATOR,
          userRoles.TKL_COMMUNITY_MANAGER
        ]
      },
      {
        id: 'faqs',
        title: 'FAQs',
        link: '/faq',
        requiredRoles: [
          userRoles.TKL_MEMBER_FREE_USER,
          userRoles.COMPREHENSIVE_PROGRAM_MEMBER_PAID_USER,
          userRoles.GPLC_PROGRAM_MEMBER_PAID_USER,
          userRoles.MICRO_COURSE_PROGRAM_MEMBER_PAID_USER,
          userRoles.KIDVISION_PROGRAM_MEMBER,
          userRoles.INVITED_USER,
          userRoles.CONTENT_ADMIN,
          userRoles.CONTENT_AUTHOR,
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_ACCOUNT_MANAGER,
          userRoles.TKL_FACILITATOR,
          userRoles.DISTRICT_ADMIN,
          userRoles.SCHOOL_ADMIN,
          userRoles.DISTRICT_FACILITATOR,
          userRoles.SCHOOL_FACILITATOR,
          userRoles.TKL_COMMUNITY_MANAGER
        ]
      }
    ]
  },
  {
    id: 'leaderboard-actions',
    title: 'Leaderboard Admin',
    icon: React.createElement(Settings, {
      size: 20,
      color: "#E8EAED"
    }),
    children: [
      {
        id: 'leaderboards-tab',
        title: 'Rewards',
        link: '/leaderboards?tab=rewards',
        requiredRoles: [
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_COMMUNITY_MANAGER
        ]
      },
      {
        id: 'user-actions-tab',
        title: 'User Actions',
        link: '/leaderboards?tab=user-actions',
        requiredRoles: [
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_COMMUNITY_MANAGER
        ]
      },
      {
        id: 'analytics-tab',
        title: 'Analytics',
        link: '/leaderboards?tab=analytics',
        requiredRoles: [
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_COMMUNITY_MANAGER
        ]
      },
      {
        id: 'faq-management-tab',
        title: 'FAQ Management',
        link: '/leaderboards?tab=faq',
        requiredRoles: [
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_COMMUNITY_MANAGER
        ]
      },
      {
        id: 'user-management-tab',
        title: 'User Management',
        link: '/leaderboards?tab=user-mgmt',
        requiredRoles: [
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_COMMUNITY_MANAGER
        ]
      }
    ]
  },
  {
    id: 'instructor-reviews',
    title: 'Instructor Reviews',
    icon: React.createElement(Trophy, {
      size: 20,
      color: "#E8EAED"
    }),
    children: [
      {
        id: 'instructor-review',
        title: 'Instructor Review Comp',
        link: '/course-review/true',
        requiredRoles: [
          userRoles.CONTENT_ADMIN,
          userRoles.CONTENT_AUTHOR,
          userRoles.TKL_ACCOUNT_MANAGER,
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_FACILITATOR,
        ]
      },
      {
        id: 'instructor-review-gplc',
        title: 'Instructor Review GPLC',
        link: '/course-review-gplc',
        requiredRoles: [
          userRoles.CONTENT_ADMIN,
          userRoles.CONTENT_AUTHOR,
          userRoles.TKL_ACCOUNT_MANAGER,
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_FACILITATOR,
        ]
      },
      {
        id: 'instructor-review-micro',
        title: 'Instructor Review Micro',
        link: '/course-review-micro',
        requiredRoles: [
          userRoles.CONTENT_ADMIN,
          userRoles.CONTENT_AUTHOR,
          userRoles.TKL_ACCOUNT_MANAGER,
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_FACILITATOR,
        ]
      },
      {
        id: 'instructor-review-kidvision',
        title: 'Instructor Review Kidvision',
        link: '/course-review-kidvision',
        requiredRoles: [
          userRoles.CONTENT_ADMIN,
          userRoles.CONTENT_AUTHOR,
          userRoles.TKL_ACCOUNT_MANAGER,
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_FACILITATOR,
        ]
      }
    ]
  },
  {
    id: 'data-admin',
    title: 'Admin Data & Reports',
    icon: React.createElement(Settings, {
      size: 20,
      color: "#E8EAED"
    }),
    children: [
      {
        id: 'master-data',
        title: 'Master Data',
        link: '/masterData',
        requiredRoles: [userRoles.SYSTEM_ADMIN]
      },
      {
        id: 'tkl-admin',
        title: 'TKL Admin Data',
        link: '/tklAdmin',
        requiredRoles: [userRoles.SYSTEM_ADMIN]
      },
      {
        id: 'reports',
        title: 'Reports',
        link: '/tklReports',
        requiredRoles: [userRoles.SYSTEM_ADMIN]
      },
      {
        id: 'file-storage',
        title: 'File Storage',
        link: '/fileStorage',
        requiredRoles: [
          userRoles.CONTENT_ADMIN,
          userRoles.SYSTEM_ADMIN,
          userRoles.TKL_FACILITATOR,
          userRoles.CONTENT_AUTHOR,
        ]
      }
    ]
  },
  {
    id: 'help',
    title: 'Help',
    link: '#',
    icon: React.createElement(Target, {
      size: 20,
      color: "#E8EAED"
    }),
    requiredRoles: [userRoles.ANY_USER],
    children: [],
    onClick: () => {
      if ((window as any).Intercom) {
        (window as any).Intercom('show');
      }
    }
  }
];

export default mainMenuItems;